module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    'primary': '#00377C',
                    'secondary': '#C4351C',

                    // Added because colors in palette automatically enter canvas color choices
                    'slate-100': '#F1F5F9'
                }
            },
            backgroundImage: {
                'gradient-text': 'linear-gradient(135deg, var(--palette-primary) 0%, var(--palette-secondary) 100%)',
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
        require('tailwind-scrollbar'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/**/*.{vue,js,scss,php}',
    ],
};
